// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-3d"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 3L18 6.5V13.5L12 17L6 13.5V6.5L12 3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.4 12.2437C3.31551 13.16 2 14.5032 2 16.0001C2 18.7615 6.47715 21.0001 12 21.0001C17.5228 21.0001 22 18.7615 22 16.0001C22 14.5032 20.6845 13.16 18.6 12.2437","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 10L17.6667 6.85M12 10V16.65M12 10L6.33333 6.85M12 3L18 6.5V13.5L12 17L6 13.5V6.5L12 3Z","strokeWidth":"props.strokeWidth"}}]}]};

const Map3DIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-3d',
    ref,
    icon: element,
  },
));

Map3DIcon.displayName = 'Map3DIcon';

export default Map3DIcon;
